import { Component, inject, Inject, Injector } from '@angular/core';
import { NavigationEnd, RouterOutlet } from '@angular/router';
import { CoreClass } from './core/base/core.class';
import { CommonModule, DOCUMENT } from '@angular/common';
import { destroy } from './core/shared/helpers/destroy';
import { TranslateService } from '@ngx-translate/core'; 
import { COMMON_MODULES, ROUTES } from './core/constants';
import { ShepherdService } from 'angular-shepherd';
import * as en from '../assets/i18n/en.json';
import * as fr from '../assets/i18n/fr.json';
import * as es from '../assets/i18n/es.json';
import * as zh from '../assets/i18n/zh.json';
import { AuthService } from './core/services';
import { FaviconService } from './core/services/favicon.service';
import { environment } from '@src/environments/environment';
import { GlobalSpinnerComponent } from './core/shared/global-spinner/global-spinner.component';
import { APP_INITIALIZER, NgModule } from '@angular/core';

@Component({
  selector: 'app-root', 
  templateUrl: './app.component.html',
  styleUrl: './app.component.sass',
  imports: [CommonModule, RouterOutlet,  ...COMMON_MODULES, GlobalSpinnerComponent],
  providers: [ShepherdService]
})
export class AppComponent extends  CoreClass{
  
  private destroy$ = destroy();
  public title = 'wow-consumer-angular';
  authService = inject(AuthService);
 private cleanupBodyScrollLocks(): void {
    // Bootstrap/jQuery modals & offcanvas can leave body scroll locked across route changes
    document.body.classList.remove('modal-open', 'sidebar-open');
    document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private translate: TranslateService, 
    private injector: Injector,
    private faviconService: FaviconService
  ) {
    super(injector)
    this.translate.setTranslation('en', en, true);
    this.translate.setTranslation('fr', fr, true);
    this.translate.setTranslation('es', es, true);
    this.translate.setTranslation('zh', zh, true);
    this.translate.setDefaultLang('en');
    // this.translate.use('en');
     this.translate.use('fr');
    this.sharedService.appConfig$.pipe(this.destroy$()).subscribe({
      next: appConfig => {
        const lang =
          this.sharedService.localService.get('language', false)?.code?.toLowerCase() || 'en';
        const code = lang || 'en';
        if (code != this.translate.currentLang?.toLowerCase()) {
          this.translate.setDefaultLang(code);
          this.translate.use(code);
        }
        if (this.document.documentElement.lang?.toLowerCase() !== code) {
          this.document.documentElement.lang = code;
        }
      },
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        console.log('navigated');
        this.cleanupBodyScrollLocks();
         this.handleVerifyProfileRedirection();
         
        // setTimeout(() => {
        //   window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        // }, 0);
      }
    });
  }

  handleVerifyProfileRedirection() {    
    const user = this.storageService.getUserInformation();
    
    const currentUrl = this.router.url;
    // 🚫 skip for error page
    if (currentUrl.includes('/error')) return;

    if (this.authService.isLoggedIn() && user && user.firstLogin == false) {
      setTimeout(() => this.router.navigate([ROUTES.verifyProfile]));
    } else {
      this.sharedService.removeNavbarLinks = false;
    }
  }

  ngOnInit() {
    const tenant = environment.TENANT;
    
    switch(tenant) {
      case 'wow':
        this.faviconService.changeFavicon('wow-health.ico');
        break;
      case 'laasy':
        this.faviconService.changeFavicon('laasy.ico');
        break;
      case 'unifywell':
        this.faviconService.changeFavicon('unifywell.ico');
        break;
      default:
        this.faviconService.changeFavicon('wow-health.ico');
    }
  }
}
